<template>
<div>
  <v-container>
  <HandleCreateNewFYAdditionalDataGrp
      :dialog="showAdditionalDataGrpDialog"
      :response="aditionalDataResultObj"
      :programName="programName"
      @openCloseDialog="openCloseDialog"
      />
<v-dialog
      v-model="isDialog"
      persistent
      max-width="60vw">
      <v-overlay :value="overlay">
        <v-progress-circular
          indeterminate
          size="64"
        ></v-progress-circular>
      </v-overlay>
              <v-card>
          <v-card-title>
            <span></span>
          </v-card-title>
          <v-card-text>
            <v-form ref="form">
              <v-container>
                <v-row align="center">
                  <v-col cols="3">
                    <v-text-field
                    v-model.number="nextFiscalYear"
                    label="Fiscal Year"
                    type="number"
                    >
                    </v-text-field>
                  </v-col>
                </v-row>
              </v-container>
            </v-form>
              <v-btn
                color="blue darken-1"
                text
                @click="performAction"
              >
                Create
              </v-btn>
              <v-btn
              color="blue darken-1"
              text
              @click="close"
            >
              Cancel
            </v-btn>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-container>
  </div>
  </template>

<script>
import { mapState, mapActions } from 'vuex';
import HandleCreateNewFYAdditionalDataGrp from '../../../common/createNewFiscalYear/HandleCreateNewFYAdditionalDataGrp.vue';
import { isEmptyObject } from '../../../../util/shared/vue-global';

export default {
  name: 'taxPaymentCreateFY',
  components: {
    HandleCreateNewFYAdditionalDataGrp,
  },
  props: {
    dialog: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    nextFiscalYear: '',
    overlay: false,
    showAdditionalDataGrpDialog: false,
    aditionalDataResultObj: {},
    programName: 'taxPayment',
  }),
  created() {
    this.initializeDialogBox();
  },
  computed: {
    ...mapState({
      fiscalYearList: (state) => state.tax.taxCommon.fiscalYearList,
    }),
    isDialog: {
      get() {
        return this.dialog;
      },
      set(value) {
        this.$emit('dialogVal', value);
      },
    },
  },
  methods: {
    ...mapActions('tax/taxCommon', [
      'loadFiscalYearList',
    ]),
    ...mapActions('createNewFiscalYearManager', ['createNewFiscalYear']),
    onFyChange() {
      this.currentFiscalYear = this.nextFiscalYear - 1;
    },
    initializeDialogBox() {
      this.loadFiscalYearList({})
        .then(() => {
          const response = this.fiscalYearList || [];
          if (response && response.length > 0) {
            const currentFiscalYear = response[0];
            this.currentFiscalYear = currentFiscalYear;
            this.nextFiscalYear = this.currentFiscalYear + 1;
          }
        })
        .catch((error) => {
        // handle error
          console.error('Error loading fiscal year list:', error);
        });
    },
    async handleCreateNewFiscalYearResult(resultObj) {
      if (!isEmptyObject(resultObj)) {
        if ((resultObj.componentStatusArr || []).length > 0) {
          this.showAdditionalDataGrpDialog = true;
          this.aditionalDataResultObj = resultObj;
          this.programName = resultObj.programName;
        }
      }
    },
    async taxPaymentCreateNewFiscalYear() {
      const result = await this.createNewFiscalYear({
        programName: this.programName,
        nextFiscalYear: this.nextFiscalYear,
        currentFiscalYear: this.currentFiscalYear,
      });
      return result;
    },
    async performAction() {
      this.overlay = true;
      this.onFyChange();
      const resultObj = await this.taxPaymentCreateNewFiscalYear();
      this.handleCreateNewFiscalYearResult(resultObj);
      this.overlay = false;
      this.close();
    },
    close() {
      this.isDialog = false;
    },
    openCloseDialog(val) {
      this.showAdditionalDataGrpDialog = val;
    },
  },
};
</script>
